<div style="padding-top: 120px; padding-bottom: 30px;">
  <h2 class="text-center">Ayuda Inmediata  
    <a href="https://chatgpt.com/g/g-677ed0144b1c81918ab4601153ebe715-asistente-de-marcas-impi" class="btn btn-info">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-alexa" viewBox="0 0 16 16">
        <path d="M7.996 0A8 8 0 0 0 0 8a8 8 0 0 0 6.93 7.93v-1.613a1.06 1.06 0 0 0-.717-1.008A5.6 5.6 0 0 1 2.4 7.865 5.58 5.58 0 0 1 8.054 2.4a5.6 5.6 0 0 1 5.535 5.81l-.002.046-.012.192-.005.061a5 5 0 0 1-.033.284l-.01.068c-.685 4.516-6.564 7.054-6.596 7.068A7.998 7.998 0 0 0 15.992 8 8 8 0 0 0 7.996.001Z"/>
      </svg>
      Agente AI Propiedad Industrial</a>
      <a href="https://chatgpt.com/g/g-67daf3c674648191a70438f989221f5e-agente-cotizador-de-servicios-legales-y-contables" class="btn btn-primary">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-alexa" viewBox="0 0 16 16">
          <path d="M7.996 0A8 8 0 0 0 0 8a8 8 0 0 0 6.93 7.93v-1.613a1.06 1.06 0 0 0-.717-1.008A5.6 5.6 0 0 1 2.4 7.865 5.58 5.58 0 0 1 8.054 2.4a5.6 5.6 0 0 1 5.535 5.81l-.002.046-.012.192-.005.061a5 5 0 0 1-.033.284l-.01.068c-.685 4.516-6.564 7.054-6.596 7.068A7.998 7.998 0 0 0 15.992 8 8 8 0 0 0 7.996.001Z"/>
        </svg>
        Cotizador AI de servicios legales y contables</a>
    </h2>
  
  <div class="uicards mycards border border-success rounded-top" style=" background-color: white;">
   
    <div class="row"  style="padding-top: 10px; padding-left: 10px; padding-right: 10px;">
      <div class="col-sm-6">
        <div class="card h-100" style="padding-left: 0px; padding-top: 0px;">
          <!-- <div class="card-header">
          
          </div> -->
          <img src="./../../../assets/images/tracer/Apoyo_las_24_horas.png" alt="" >
          <div class="card-body">
            <h5 class="card-title"><a href="https://api.whatsapp.com/send/?phone=5215519529714&amp&text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n." style="color: #36bea6" target="_blank">Apoyo las 24 hrs.</a></h5>
            <p class="card-text">Contáctanos por WhatsApp.</p>
          </div>

        </div>
      </div>

      <div class="col-sm-6">
        <div class="card h-100">
            <img src="./../../../assets/images/tracer/Firma_electonica.png" alt="">
            <div class="card-body">
              <h5 class="card-title"><a href="#/administracion/signature" style="color: #36bea6">Firma Electrónica de Contrato o Documento</a></h5>
              <p class="card-text">Conoce Nuestro módulo personalizado de Firma Electrónica.</p>
            </div>
        </div>
      </div>

    </div>

<!--     
    <div class="row">
      <div class="col-sm-3">
          <div class="card h-100" style="padding-left: 0px; padding-top: 0px;">

              <img src="./../../../assets/images/tracer/Apoyo_las_24_hrs_old.png" alt="" >
              <div class="card-body">
                <h5 class="card-title"><a href="https://api.whatsapp.com/send/?phone=5215584492303&amp&text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n." style="color: #36bea6" target="_blank">Apoyo las 24 hrs.</a></h5>
                <p class="card-text">Contáctanos por WhatsApp.</p>
              </div>

          </div>
           
      </div>

      <div class="col-sm-3">
          <div class="card h-100">

              <img src="./../../../assets/images/tracer/Legal.png" alt="" >
                <div class="card-body">
                <h5 class="card-title"><a href="https://www.tracer.mx/llamada-tracer" style="color: #36bea6" target="_blank">Asesoría Legal</a></h5>
                <p class="card-text">Obtén asesoría personalizada de un Abogado Experto.</p>
              </div>

          </div>
          
      </div>

        <div class="col-sm-3">
            <div class="card h-100">

                <img src="./../../../assets/images/tracer/Contable.png" alt="" >
                <div class="card-body">
                  <h5 class="card-title">
                      <a href="https://www.tracer.mx/llamada-tracer" style="color: #36bea6" target="_blank" >Asesoría Contable</a>
                  </h5>
                <p class="card-text">Obtén asesoría personalizada de un Contador Público.</p>
                
                </div>

            </div>
            
        </div>
        <div class="col-sm-3">
            <div class="card h-100">

                <img src="./../../../assets/images/tracer/Firma_electronica_old.png" alt="">
                <div class="card-body">

                  <h5 class="card-title"><a href="#/administracion/signature" style="color: #36bea6">Firma Electrónica de Contrato o Documento</a></h5>
                  <p class="card-text">Conoce Nuestro módulo personalizado de Firma Electrónica.</p>


                  
                </div>

            </div>
            
        </div>


    </div>

    <div class="row">
      <p></p>
    </div>

    <div class="row">
        
        <div class="col-sm-6">
          <div class="card h-100" >

              
          
              <img src="./../../../assets/images/tracer/Marketplace.png" alt="">
              <div class="card-body">
                <h5 class="card-title"><a href="https://www.tracer.mx/plataforma-tracer" style="color: #36bea6" target="_blank" >Obtén un Crédito.</a></h5>
                <p class="card-text">Conoce nuestro MarketPlace Financiero.</p>
                
              </div>

          </div>
      </div>

      <div class="col-sm-6">
          <div class="card h-100" >
            <img src="./../../../assets/images/tracer/Beneficios.png" alt="">
            <div class="card-body">
                <h5 class="card-title"><a href="https://www.tracer.mx/beneficios" style="color: #36bea6"target="_blank">Beneficios de la Membresía.</a></h5>
                <p class="card-text">Conoce ahorros y descuentos en servicios legales y contables.</p>
            </div>

          </div>
      </div>

    </div>  
  </div> -->
</div>
